module.exports = __webpack_public_path__ + "img/milanesa.4b1f56a8.jpeg";